import { render, staticRenderFns } from "./AuthClientRole.vue?vue&type=template&id=7b28123f"
import script from "./AuthClientRole.vue?vue&type=script&lang=js"
export * from "./AuthClientRole.vue?vue&type=script&lang=js"
import style0 from "./AuthClientRole.vue?vue&type=style&index=0&id=7b28123f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports